import useSWR, { SWRConfiguration } from "swr";
import {
    getAppointmentList,
    getAvailableAppointmentDateList,
    getRecommendationBanner,
    getCancelBroadbandEligibility,
    getFeatureFlagList,
    getRescheduleAppointmentEligibility,
} from "./api";
import { ICancelBroadbandEligibility, IFeatureFlag } from "@modules/eirCustomersFacade/interfaces";
import { IAppointment } from "@modules/eirCustomersFacade/interfaces/models/IAppointment";
import { IAvailableAppointmentDate } from "@modules/eirCustomersFacade/interfaces/models/IAvailableAppointmentDate";
import { IRescheduleAppointmentEligibility } from "@modules/eirCustomersFacade/interfaces/models/IRescheduleAppointmentEligibility";

export const useGetFeatureFlagList = (isKeycloakReady: boolean, options: SWRConfiguration = {}) =>
    useSWR<IFeatureFlag[]>(isKeycloakReady ? ["useGetFeatureFlagList"] : null, {
        ...options,
        fetcher: getFeatureFlagList,
    });

export const useGetRecommendationBanner = (options: SWRConfiguration = {}) =>
    useSWR<string>("useGetRecommendationBanner", {
        ...options,
        fetcher: getRecommendationBanner,
    });

export const useGetCancelBroadbandEligibility = (
    isEligibleToCancel: boolean,
    orderReference: string,
    options: SWRConfiguration = {}
) =>
    useSWR<ICancelBroadbandEligibility>(
        isEligibleToCancel ? ["useGetCancelBroadbandEligibility", orderReference] : null,
        {
            ...options,
            fetcher: () => getCancelBroadbandEligibility(orderReference),
        }
    );

export const useGetAppointmentList = (options: SWRConfiguration = {}) =>
    useSWR<IAppointment[]>(["useGetAppointmentList"], {
        ...options,
        fetcher: getAppointmentList,
    });

export const useGetAvailableAppointmentDateList = (
    appointmentId: number,
    shouldFetch: boolean,
    options: SWRConfiguration = {}
) =>
    useSWR<IAvailableAppointmentDate[]>(shouldFetch ? ["useGetAvailableAppointmentDateList", appointmentId] : null, {
        ...options,
        fetcher: () => getAvailableAppointmentDateList(appointmentId),
    });

export const useGetRescheduleAppointmentEligibility = (
    appointmentId: number,
    shouldCheckEligibility: boolean,
    options: SWRConfiguration = {}
) =>
    useSWR<IRescheduleAppointmentEligibility>(
        shouldCheckEligibility ? ["useGetRescheduleAppointmentEligibility", appointmentId] : null,
        {
            ...options,
            fetcher: () => getRescheduleAppointmentEligibility(appointmentId),
        }
    );
